/* eslint-disable @typescript-eslint/no-explicit-any */
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import React, { useEffect, useState } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { Grid } from '@mui/material';
import { fonts } from '../../themes/themes';
import _ from 'lodash';

interface PropsValue {
  title: any;
  menu: any;
  onSelect?: (data: any) => void;
}
const YearFilterButton: React.FC<PropsValue> = ({ menu, onSelect, title }) => {
  const [menuItems, setMenuItems] = useState(menu ? menu : []);
  const [open, setOpen] = React.useState(false);
  const anchorRef: any = React.useRef(null);

  useEffect(() => {
    setMenuItems(menu);
  }, [menu]);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const handleSelect = (event: any, item: any) => {
    handleClose(event);
    if (onSelect) onSelect(item);
  };

  return (
    // <Box style={{height:"40px"}}>
    <Grid>
      <ButtonGroup
        ref={anchorRef}
        aria-label="split button"
        style={{
          backgroundColor: '#F5F5FA',
          borderRadius: '8px',
          height: 'auto',
          width: 'auto',
        }}
      >
        <Button
          style={{
            backgroundColor: '#F5F5FA',
            height: 'auto',
            borderRadius: '0.25em',
            color: '#7C0E6F',
            textTransform: 'capitalize',
            fontFamily: fonts.fontFamily,
            borderColor: '#FFFFFF',
            minWidth: 50,
            width: 'auto',
            padding: '11px',
          }}
        >
          {title}
        </Button>
        <Button
          style={{
            backgroundColor: '#F5F5FA',
            color: '#8F95B2',
            borderColor: '#FFFFFF',
          }}
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <i className="las la-angle-down" />
        </Button>
      </ButtonGroup>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        style={{
          zIndex: 999,
        }}
        placement="left-start"
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {_.map(menuItems, function (item) {
                    return (
                      <MenuItem
                        onClick={(e) => handleSelect(e, item)}
                        style={{ color: item.color }}
                      >
                        {item.label}
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Grid>
  );
};

export default YearFilterButton;
